<template>
  <div class="m-activity-ticketForm">
    <el-form v-if="ticketItem.isEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="入场时间" prop="enterTime" >
        <el-date-picker
          v-model="form.enterTime"
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="截止时间"
          value-format="timestamp"
          format="yyyy/MM/dd HH:mm"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <div v-if="!free" class="price-input-box">
        <el-form-item label="所需积分" prop="point">
          <el-input v-model.number="form.point" placeholder="请输入积分" oninput="value=value.replace(/[^\d]+/g,'')" >
            <template slot="append">积分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="所需金额" prop="amount">
          <el-input v-model.number="form.amount" placeholder="请输入金额" type="number"  >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </div>
      <el-form-item label="数量" prop="quantity">
        <el-input v-model.number="form.quantity" placeholder="请输入数量" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" />
      </el-form-item>

      <el-form-item label="购票须知" prop="remark">
        <el-input type="textarea" rows="6" v-model="form.remark" placeholder="请输入购票须知" maxlength="500" show-word-limit />
      </el-form-item>
    </el-form>

    <div v-else class="detail-info">
      <el-row class="row-info">
        <el-col :span="2" class="col-label">名称</el-col>
        <el-col :span="22" class="col-value">{{ form.name }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">入场时间</el-col>
        <el-col :span="22" class="col-value">
          <span>{{ form.startTime ? $moment(form.startTime).format('YYYY/MM/DD HH:mm') : '' }}</span>
          <span> - </span>
          <span>{{ form.endTime ? $moment(form.endTime).format('YYYY/MM/DD HH:mm') : '' }}</span>
        </el-col>
      </el-row>
      <el-row class="row-info" v-if="!free">
        <el-col :span="2" class="col-label">所需票价</el-col>
        <el-col :span="22" class="col-value">{{ form.point }}积分{{Number(form.amount) > 0 ? '+' + form.amount+'元': ''}}兑换一张</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">数量</el-col>
        <el-col :span="22" class="col-value">{{ form.quantity }}</el-col>
      </el-row>
      <el-row class="row-info">
        <el-col :span="2" class="col-label">购票须知</el-col>
        <el-col :span="6" class="col-value white-space remark">{{ form.remark }}</el-col>
      </el-row>
    </div>

    <div class="submit-btn">
      <div v-if="ticketItem.isEdit">
        <el-button @click="onCancel" class="mr20">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitLoading">确定</el-button>
      </div>
      <div v-else-if="isCanBaseInfoEdit">
        <auth-button auth="market:activity:update">
          <el-button type="primary" @click="onEdit">编辑</el-button>
        </auth-button>
      </div>
    </div>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import UploadImg from '@/components/UploadImg/index'
import { api_postTicketAdd, api_postTicketUpdate } from '@/api/market'

export default {
  name: "marketActivityListTicketForm",
  components: {
    AuthButton,
    UploadImg
  },
  props: {
    baseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    ticketListData: {
      type: Array,
      default() {
        return []
      }
    },
    ticketItem: {
      type: Object,
      default() {
        return {}
      }
    },
    ticketIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    tabsKey: {
      type: String,
      default() {
        return ''
      }
    },
    isCanBaseInfoEdit: {
      type: Boolean,
      default() {
        return true
      }
    },
    free: Boolean,
    participateCount:'',
  },
  data() {
    // 校验入场时间要在活动时间内
    const checkEnterTime = (rule, value, callback) => {
      console.log('value: ', value);
      if (value[0] < this.baseInfo.activityDate[0] || value[1] > this.baseInfo.activityDate[1]) {
        callback(new Error('入场时间要在活动时间之内'))
      } else if (!value[0]) {
        callback(new Error('请选择入场时间'))
      } else {
        callback()
      }
    }
    // 校验金额
    const checkAmount = (rule, value, callback) => {
      let rep = /[\.]/
      if (value == undefined) {
        callback(new Error('请填写所需金额'))
      } else if (rep.test(value * 10)) {
        callback(new Error('所需金额仅支持一位小数'))
      }else if(value.length == 0){
        callback(new Error('请填写所需金额'))
      } else if(value == 0 && this.form.point == 0){
        callback(new Error('所需积分及所需金额不能同时为0'))
      } else if(value < 0){
        callback(new Error('所需金额不得小于0'))
      } else {
        callback()
      }
    }

    return {
      submitLoading: false,
      form: {},
      rules: {
        name: [{ required: true, message: '请输入名称' }],
        enterTime: [{ validator: checkEnterTime }],
        point: [{ required: true, message: '请输入积分' }],
        amount: [{ validator: checkAmount }],
        quantity: [{ required: true, message: '请输入数量' }],
        remark: [{ required: true, message: '请输入购票须知' }],
      },
      pickerOptions: {
        disabledDate: this.disabledDateFun,
      },
    };
  },
  async created() {
    this.initCurForm() // 初始化当前表单
  },
  methods: {
    // 初始化当前表单
    initCurForm() {
      this.form = {
        ...this.ticketItem,
        enterTime: [this.ticketItem.startTime, this.ticketItem.endTime]
      }
    },

    // 点击编辑按钮
    onEdit() {
      this.$emit('onIsEdit', true)
    },

    // 禁用日期
    disabledDateFun(date) {
      let start = this.$moment(this.baseInfo.activityDate[0]).subtract(1, 'day').valueOf()
      let end = this.$moment(this.$moment(this.baseInfo.activityDate[1]).format('YYYY-MM-DD')).add(1, 'day').valueOf()-1
      if (this.$moment(date).valueOf() < start || this.$moment(date).valueOf() > end) {
        return true
      }
    },

    // 点击提交按钮
    onSubmit() {
      if(this.form.amount == 0 && this.form.point == 0){
        this.$baseMessage('所需积分及所需金额不能同时为0', 'error');
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let params = {
              ...this.form,
              activityId: this.$route.query.id,
              free: this.free,
              participateCount:this.participateCount,
              startTime: this.form.enterTime && this.form.enterTime[0] ? this.form.enterTime[0] : null,
              endTime: this.form.enterTime && this.form.enterTime[1] ? this.form.enterTime[1] : null,
            }

            delete params.enterTime
            delete params.isEdit
            console.log('params: ', params);
            console.log(this.ticketListData.length)
            if(params.participateCount.length <= 0){
              this.$baseMessage(`请输入允许单用户参与场次数量`, 'error')
              this.submitLoading = false
              return
            }
            if(params.participateCount>this.ticketListData.length){
              this.$baseMessage(`允许单用户参与场次数量不能多于门票数量`, 'error')
              this.submitLoading = false
              return
            }
            // return

            let res = params.id ? await api_postTicketUpdate(params) : await api_postTicketAdd(params)
            console.log('res: ', res);

            this.$emit('onIsEdit', false)
            this.$emit('getTicketData')
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    // 点击取消
    onCancel() {
      if (this.form.id) {
        this.$emit('onIsEdit', false)
      } else {
        this.$emit('delTicketOk', this.ticketIndex)
      }
    },
  },
  watch: {

  }
};
</script>

<style lang="scss" scoped>
.m-activity-ticketForm {
  width: 100%;
  position: relative;

  .price-input-box {
    // display: flex;
    .input-remark {
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      color: #999999;
    }
  }

  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;

      .img {
        border: 1px solid #eee;
        border-radius: 2px;
        width: 150px;
        height: 150px;
      }

      &.white-space {
        white-space: pre-wrap;
      }

      &.remark {
        height: 126px;
        overflow-y: auto;
        border: 1px solid #ccc;
        padding: 5px 15px;
      }
    }
  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .submit-btn{
    text-align: right;
    margin-top: 20px;
  }
}
</style>
